import {Pipe, PipeTransform} from '@angular/core';
import {
  dataZoneToDeploymentSubscription,
  DeploymentSubscription
} from 'src/app/models/data-zone/deployment-subscription';
import {Deployment} from 'src/app/models/deploy/deployment';
import {DeploymentClass} from 'src/app/models/instance-class';

@Pipe({
    name: 'resolveDeploymentSubscription',
    standalone: false
})
export class ResolveDeploymentSubscription implements PipeTransform {
  transform(deployment: Deployment): DeploymentSubscription {
    // For dev instance
    if (deployment.deploymentClass === DeploymentClass.D) {
      return DeploymentSubscription.DEVELOPMENT;
    }

    return dataZoneToDeploymentSubscription(deployment.dataZone);
  }
}
